import axios from "../helper/Axios.js";
import { adminUrl } from "../config/config.js";
// import { Delete, Get, Patch, Post, Put } from "./RestClient.js";

export async function getPackageSportCourtType({
    name, sessionType, sessionStart, sessionEnd, priceType, priceStart, priceEnd, isActive, sort, merchantId, placeId, placeIds
}) {
    try {
        let packages = await axios.Get({
            url: `${adminUrl}/package-sport-court-type`,
            params: {
                name: name || '',
                sessionType: sessionType || '',
                sessionStart: sessionStart || '',
                sessionEnd: sessionEnd || '',
                priceType: priceType || '',
                priceStart: priceStart || '',
                priceEnd: priceEnd || '',
                isActive: isActive || '',
                sort: sort || '',
                merchantId: merchantId || '',
                placeId: placeId || '',
                placeIds: placeIds || [],
            }
        });

        if (packages.statusCode !== 200) {
            return { error: packages.message };
        }

        return { data: packages.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function createPackageSportCourtType(body) {
    try {
        let packages = await axios.Post({
            url: `${adminUrl}/package-sport-court-type`,
            data: body
        });

        if (packages.statusCode !== 200) {
            return { error: packages.message };
        }

        return { data: packages.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function loadPackageSportCourtType(id) {
    try {
        let packages = await axios.Get({
            url: `${adminUrl}/package-sport-court-type/${id}`,
        });

        if (packages.statusCode !== 200) {
            return { error: packages.message };
        }

        return { data: packages.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function updatePackageSportCourtType(body) {
    try {
        let packages = await axios.Post({
            url: `${adminUrl}/package-sport-court-type/update`,
            data: body
        });

        if (packages.statusCode !== 200) {
            return { error: packages.message };
        }

        return { data: packages.data };
    } catch (e) {
        return { error: e.response.data }
    }
}

export async function updatePackageSportCourtTypeGlobal(body) {
    try {
        let packages = await axios.Post({
            url: `${adminUrl}/package-sport-court-type/update-global`,
            data: body
        });

        if (packages.statusCode !== 200) {
            return { error: packages.message };
        }

        return { data: packages.data };
    } catch (e) {
        return { error: e.response.data }
    }
}

export async function deletePackageSportCourtType(id) {
    try {
        let response = await axios.Delete({
            url: `${adminUrl}/package-sport-court-type/delete/${id}`,
        });

        if (response.statusCode !== 200) {
            return { error: response.message };
        }
        return { data: response.data };
    } catch (e) {
        // return { error: e.response.data.errorCode }
        return { error: e.response.data }
    }
}